

import React, { useEffect, useState } from "react";
import "./homecities.css";

import { useNavigate } from "react-router-dom";
import HomeService from "../../../Services/HomeService";

import { FaArrowRightLong } from "react-icons/fa6";
import { HiOutlineLocationMarker } from "react-icons/hi";

const NewWinnersHomeCities = ({ allowedCities, title }) => {

    const navigate = useNavigate();

    const [cities, setCities] = useState([]);

    const [loginProfile, setLoginProfile] = useState(null);

    const [userId, setUserId] = useState(null);

    /* =========================
       LOGIN PROFILE
    ========================= */

    useEffect(() => {

        const getLoginProfile = async () => {

            try {

                const res = await HomeService.getLoginProfile();

                if (res?.status) {
                    setLoginProfile(res?.data);
                    setUserId(res?.data?._id);
                }

            } catch (error) {
                console.log(error);
            }
        };

        getLoginProfile();

    }, []);

    /* =========================
       GET CITIES
    ========================= */

    const getAllCity = async () => {

        try {

            const res = await HomeService.getAllCities();

            if (res?.data) {
                setCities(res?.data);
                console.log("seaa", res.data);

            }

        } catch (error) {
            console.log(error);
        }
    };


    useEffect(() => {
        getAllCity();
    }, []);

    /* =========================
       HANDLE CLICK
    ========================= */

    const handleCityFilter = async (userID, ele) => {

        if (title === "Working in cities") {

            if (loginProfile === null) {
                navigate("/profile");
                return;
            }

            navigate("/propertyList", {
                state: {
                    cityId: ele?._id,
                    loggedInUserId: userID,
                },
            });
        }
    };

    return (

        <section className="winnercards-main-section">

                  <div className="moderntesti-blur-one"></div>

      <div className="moderntesti-blur-two"></div>

            {/* TOP */}

            <div className="winnercards-top-wrapper">

                <div className="elitefame-top-wrapper">

                    <span className="winnercards-subtitle">
                        Featured Locations
                    </span>

                    <h2 className="insightx-title_n">
                        {title || "Popular Cities"}
                    </h2>

                </div>

            </div>

            {/* GRID */}

            <div className="winnercards-grid-wrapper">

                {(allowedCities?.length
                    ? cities?.filter((e) =>
                        allowedCities
                            ?.map((city) =>
                                city?.trim()?.toLowerCase()
                            )
                            ?.includes(
                                e?.name?.trim()?.toLowerCase()
                            )
                    )
                    : cities
                )?.map((e, i) => (

                    <div
                        key={i}
                        className="winnercards-card"
                        onClick={() =>
                            handleCityFilter(userId, e)
                        }
                        style={{
                            cursor:
                                title === "Working in cities"
                                    ? "pointer"
                                    : "default",
                        }}
                    >

                        {/* IMAGE */}

                        <div className="winnercards-image-wrapper">

                            <img
                                src={e?.image}
                                alt={e?.name}
                            />

                            <div className="winnercards-overlay"></div>

                            <div className="winnercards-location-badge">

                                <HiOutlineLocationMarker />

                                <span>Prime Area</span>

                            </div>

                        </div>

                        {/* CONTENT */}

                        <div className="winnercards-content">

                            <h3>
                                {e?.name}
                            </h3>


                            {/* <p>
                                Explore premium properties,
                                investment opportunities &
                                luxury apartments in {e.name}.
                            </p> */}

                            {/* BOTTOM */}

                            <div className="winnercards-bottom">

                                <div>

                                    <h4>
                                        {i + 12}K+
                                    </h4>

                                    <span>
                                        Properties
                                    </span>

                                </div>

                                <div className="winnercards-arrow">

                                    <FaArrowRightLong />

                                </div>

                            </div>

                        </div>

                    </div>

                ))}

            </div>

        </section>
    );
};

export default NewWinnersHomeCities;